import { AppSubjectEnum } from '../enums/app-subject.enum';

import { AbilityDto } from './ability.dto';

export class SubjectAbilitiesDto {
	subject!: AppSubjectEnum;
	abilities!: AbilityDto[];
}
